module.exports = __webpack_public_path__ + "static/media/feifengshan4.af00aeaf.webp";